import Date from "common/values/date/date";
import Guid from "common/values/guid/guid";
import { DocumentContentsAccess, GeneralDocumentAccess } from "./resources/documents-resources";
import { Resource } from "./resources/general";
import { KnowledgeBaseAccess } from "./resources/knowledge-base-resources";
import { LegalEntityAccess } from "./resources/legal-entities-resources";
import { MarketplaceAccess } from "./resources/marketplace-resources";
import { CommunicationsAccess } from "./resources/messaging-resources";
import { NotificationsAccess } from "./resources/notifications-resources";
import { LoginAccess, UserNetworkingAccess } from "./resources/users-resources";
import {
  ContractsAccess, CurrencyFieldsAccess, DiscountsAccess,
  FeeSchedulesAccess, InvoicesAccess,
  ProposalsAccess,
  TeamsAccess,
  WorkAgreementsAccess
} from "./resources/work-resources";

export default class Permission {
  public id?: Guid;
  public resource: Resource;
  public grantorUserId: Guid;
  public granteeUserId: Guid;
  public disabledDate?: Date;
  public createdDate?: Date;
  public parentId?: Guid;
  public parentResource?: Resource;
  public note?: string;

  constructor(
    resource: Resource,
    granteeUserId: Guid,
    grantorUserId: Guid,
    id?: Guid,
    parentId?: Guid,
    parentResource?: Resource,
    createdDate?: Date,
    disabledDate?: Date,
    note?: string
  ) {
    this.resource = resource;
    this.granteeUserId = granteeUserId;
    this.grantorUserId = grantorUserId;
    this.parentResource = parentResource;
    this.parentId = parentId;
    this.id = id;
    this.createdDate = createdDate;
    this.disabledDate = disabledDate;
    this.note = note;
  }

  public get isDisabled(): boolean {
    return !!this.disabledDate;
  }

  public get isVirtual(): boolean {
    return !this.id;
  }

  public clone(): Permission {
    return new Permission(
      this.resource,
      this.granteeUserId,
      this.grantorUserId,
      this.id ? this.id.clone() : undefined,
      this.parentId ? this.parentId.clone() : undefined,
      this.parentResource,
      this.createdDate ? this.createdDate.clone() : undefined,
      this.disabledDate ? this.disabledDate.clone() : undefined,
      this.note ? this.note : undefined
    );
  }

  public static topLevelResources(): Resource[] {
    return [
      ...LoginAccess.getPermutations(),
      ...LegalEntityAccess.getPermutations(),
      ...UserNetworkingAccess.getPermutations(),
      ...CommunicationsAccess.getPermutations(),
      ...NotificationsAccess.getPermutations(),
      ...GeneralDocumentAccess.getPermutations(),
      ...DocumentContentsAccess.getPermutations(),
      ...MarketplaceAccess.getPermutations(),
      ...WorkAgreementsAccess.getPermutations(),
      ...ProposalsAccess.getPermutations(),
      ...TeamsAccess.getPermutations(),
      ...ContractsAccess.getPermutations(),
      ...FeeSchedulesAccess.getPermutations(),
      ...CurrencyFieldsAccess.getPermutations(),
      ...DiscountsAccess.getPermutations(),
      ...InvoicesAccess.getPermutations(),
      ...KnowledgeBaseAccess.getPermutations()
    ];
  }
}
